import React from 'react';
import { useTheme } from '../../../contexts/Theme/ThemeContext';
import { ImportarArquivoContainer } from './styles';

interface ImportarArquivoProps {
  onVoltar?: () => void;
}

const ImportarArquivo: React.FC<ImportarArquivoProps> = ({onVoltar}) => {

  const {theme} = useTheme();

  return (
    <ImportarArquivoContainer  theme={theme}>
      <>
        <p className="fonteTexto">
          Com o recurso de importação em massa, você pode cadastrar vários produtos de uma só vez por meio de uma planilha. <br />
          Além disso, após a importação dos produtos, é possível fazer o upload das imagens em lote, garantindo que cada item tenha sua foto associada 
          ao produto através do SKU.
        </p>
        <p>
          <span className="fonteSubtitulo">Orientações</span>
        </p>
        <ul className="fonteTexto">
          <li>
            Você vai precisar de um arquivo no formato .CSV (Excel), com os dados separados por ponto e vírgula (;), vírgula (,) ou ponto (.);
          </li>
          <li>
            Cada coluna do arquivo deve conter as informações que você vai
            cadastrar e cada linha representa um produto;
          </li>
          <li>
            <b>A primeira linha de cada coluna deve indicar qual é a informação a ser cadastrada; </b>
          </li>
          <li>
            Todo produto deve conter as seguintes informações: Nome (até 64 caracteres) | SKU | Categoria; <br />
            Os demais campos são opcionais, sendo eles: Subcategoria | SKU da Variação | Tipo Variação Principal | Valor Variação Principal | Tipo Variação Secundária | Valor Variação Secundária | Preço | Peso (g) | Estoque | Descrição | Multiplicador | Quantidade Mínima | Solicitar Observação | Tag de destaque | Tags de característica; <br />
          </li>
          <li>
            O campo <b>Tags de característica</b> aceita múltiplas tags na mesma célula, separadas por vírgula;
          </li>
          <li>
            O campo estoque é opcional, caso não seja informado nenhum valor, será considerado estoque ilimitado;
          </li>
          <li>
            As variações serão agrupadas pelo campo <b>SKU</b>;
          </li>
          <li>
            Os campos <b>Tipo Variação Principal</b> e <b>Tipo Variação Secundária</b> são opcionais; quando não informados, a variação será cadastrada como <b>Não definida</b>;
          </li>
          <li>
            O campo SKU não pode conter hífen (-) ou underline (_), somente ponto (.).
          </li>
        </ul>
        
      </>
    </ImportarArquivoContainer >
  )
}

export default ImportarArquivo;